import "../assets/css/StatCard.css";

function StatCard({ title, value, action, onClick }) {
  return (
    <div className="stat-card" onClick={onClick}>
      <div className="stat-card-content">
        <span className="stat-title">{title}</span>
        <span className="stat-value">{value}</span>
      </div>
      {action && action}
    </div>
  );
}

export default StatCard;